import type {
  LeaderboardResult,
  LeaderboardSubmitParams,
} from "../types";
import type { Transport } from "../transport";

/**
 * Лидерборды. Разраб создаёт их в `/dev/games/[id]/leaderboards`
 * (имя, сортировка, max score для антифрода), игра submit'ит счета через SDK.
 *
 * Антифрод:
 *   - max_realistic_score — если score > лимита, помечаем подозрительным и не показываем публично
 *   - min_duration — если submit идёт раньше N секунд с начала игры, блокируется
 *   - rate_limit — 1 submit в минуту на юзера per лидерборд
 *   - IP-группировка — подозрительные паттерны отсылаются в админку
 */
export function createLeaderboard(t: Transport) {
  return {
    /**
     * Отправить свой результат в лидерборд.
     * Если такой юзер уже в лидерборде — обновляется только если новый score больше.
     */
    submit(params: LeaderboardSubmitParams): Promise<{
      rank: number | null;
      isPersonalBest: boolean;
    }> {
      return t.request("leaderboard.submit", params);
    },

    /**
     * Получить топ лидерборда + запись текущего юзера.
     */
    get(
      name: string,
      options: { limit?: number; range?: "daily" | "weekly" | "all_time" } = {},
    ): Promise<LeaderboardResult> {
      return t.request<LeaderboardResult>("leaderboard.get", {
        name,
        limit: options.limit ?? 10,
        range: options.range ?? "all_time",
      });
    },
  };
}

export type LeaderboardApi = ReturnType<typeof createLeaderboard>;
